export default __webpack_public_path__ + "static/media/hyunslide3.e3d7ea3e.jpg";